import React from 'react';
import {
    PayPalScriptProvider,
    ScriptProviderProps,
    ReactPayPalScriptOptions,
} from '@paypal/react-paypal-js';

interface PaypalPaymentFormProps extends Omit<ScriptProviderProps, 'options'> {
    options?: ScriptProviderProps['options'];
    country?: keyof typeof optionsByCountry;
}

const optionsByCountry: Record<
    'US',
    Pick<ReactPayPalScriptOptions, 'locale' | 'currency'>
> = {
    US: {
        locale: 'en_US',
        currency: 'USD',
    },
};

const PaypalPaymentForm: React.FC<PaypalPaymentFormProps> = ({
    children,
    options = {},
    country = 'US',
    ...props
}) => {
    const countryOptions = optionsByCountry[country];
    return (
        <PayPalScriptProvider
            options={{
                clientId: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID as string,
                components: 'buttons',
                intent: 'subscription',
                vault: true,
                ...countryOptions,
                ...options,
            }}
            {...props}>
            {children}
        </PayPalScriptProvider>
    );
};

export default PaypalPaymentForm;
